<template>
    <div class="teach-resource-build">
        <div class="teach-resource-build-top">
            <div class="title">学科应用分析</div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teach-resource-build-box">
            <div class="region-panorama-board-top-filter">
                <div class="filter-btn" @click="selectLegend(0)" :class="filterSelect == 0 ? 'is-select' : ''">小学</div>
                <div class="filter-btn" @click="selectLegend(1)" :class="filterSelect == 1 ? 'is-select' : ''">初中</div>
                <div class="filter-btn" @click="selectLegend(2)" :class="filterSelect == 2 ? 'is-select' : ''">高中</div>
            </div>
            <div id="subjectApplicationAnalysis" style="width:50%;height: 100%"></div>
            <div class="right-container">
                <div class="right-container-wrap">
                    <div class="subject-count-title">
                        <div class="subject-title" style="width: 30%">学科</div>
                        <div class="count-title" style="width: 70%">使用次数</div>
                    </div>
                    <template v-for="(item, index) in data" v-if="data.length > 0 && index < 6">
                        <div class="subject-count-name" v-if="index % 2 === 1" style="background-color: rgba(16, 34, 67, 0.5)">
                            <span class="subject-name" style="width: 30%">{{
                                item.subject_name
                            }}</span>
                            <span class="submit-count" style="width: 70%" :title="item.count + '次'">{{ item.count
                            }}次</span>
                        </div>
                        <div class="subject-count-name" v-else>
                            <span class="subject-name" style="width: 30%">{{
                                item.subject_name
                            }}</span>
                            <span class="submit-count" style="width: 70%" :title="item.count + '次'">{{ item.count
                            }}次</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
<script>
export default {
    name: 'subjectApplicationAnalysis',
    data() {
        return {
            color: [
                { offset: 0, color: "#00FEFF" },
                { offset: 0.9, color: "#24C4DC" },
                { offset: 1, color: "#24C4DC" },
            ],
            data:[],
            filterSelect: 0,
            subjectMap: [{ subjectName: '语文', useNum: 1548 }, { subjectName: '数学', useNum: 524 }, { subjectName: '物理', useNum: 623 }, { subjectName: '化学', useNum: 204 }, { subjectName: '地理', useNum: 623 }, { subjectName: '生物', useNum: 204 },],
        }
    },
    methods: {
    /**
     * 图例切换
     */
    selectLegend(item) {
      let seriesDataArr = [];
      let indicator = [];
      this.filterSelect = item;
      let color='';
      if (item == "0") {
        seriesDataArr = [
          {
            value: [
              3755486,
              2430918,
              1919708,
              697382,
              457800,
              428806,
              366240,
              328090,
              24416,
            ],
            name: "小学",
            areaStyle: {
              normal: {
                opacity: 0.78,
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#00FEFF" },
                  { offset: 0.9, color: "#24C4DC" },
                  { offset: 1, color: "#24C4DC" },
                ]),
              },
            },
          },
        ];
        indicator = [
          { name: "语文" },
          { name: "数学" },
          { name: "英语" },
          { name: "体育" },
          { name: "音乐" },
          { name: "美术" },
          { name: "信息技术" },
          { name: "科学" },
          { name: "道德与法治" },
        ];
        this.color=[ { offset: 0, color: "#00FEFF" },
                  { offset: 0.9, color: "#24C4DC" },
                  { offset: 1, color: "#24C4DC" }];
        this.data = [
          {
            subject_name: "语文",
            count: "3755486",
          },
          {
            subject_name: "数学",
            count: "2430918",
          },
          {
            subject_name: "英语",
            count: "1919708",
          },
          {
            subject_name: "体育",
            count: "697382",
          },
          {
            subject_name: "音乐",
            count: "457800",
          },
          {
            subject_name: "美术",
            count: "428806",
          },
        ];
          color="#2783CD";
      } else if (item == "1") {
        seriesDataArr = [
          {
            value: [
              1036154,
              924756,
              669914,
              306726,
              239582,
              225848,
              210588,
              169386,
              28994,
            ],
            name: "初中",
            areaStyle: {
              normal: {
                opacity: 0.78,
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#ED8167" },
                  { offset: 0.9, color: "#ED8167" },
                  { offset: 1, color: "#ED8167" },
                ]),
              },
            },
          },
        ];
        indicator = [
          { name: "数学" },
          { name: "语文" },
          { name: "英语" },
          { name: "物理" },
          { name: "生物" },
          { name: "历史" },
          { name: "体育" },
          { name: "化学" },
          { name: "政治" },
        ];
        this.color=[ { offset: 0, color: "#ED8167" },
                  { offset: 0.9, color: "#ED8167" },
                  { offset: 1, color: "#ED8167" }];
        this.data = [
          {
            subject_name: "数学",
            count: "1036154",
          },
          {
            subject_name: "语文",
            count: "924756",
          },
          {
            subject_name: "英语",
            count: "669914",
          },
          {
            subject_name: "物理",
            count: "306726",
          },
          {
            subject_name: "生物",
            count: "239582",
          },
          {
            subject_name: "历史",
            count: "225848",
          },
        ];
          color="#FFB888";
      } else if (item == "2") {
        seriesDataArr = [
          {
            value: [
              346402,
              267050,
              250264,
              187698,
              120554,
              111398,
              102242,
              102242,
              93086
            ],
            name: "高中",
            areaStyle: {
              normal: {
                opacity: 0.78,
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#FAE17C" },
                  { offset: 0.9, color: "#FAE17C" },
                  { offset: 1, color: "#FAE17C" },
                ]),
              },
            },
          },
        ];
        indicator = [
          { name: "数学" },
          { name: "语文" },
          { name: "英语" },
          { name: "物理" },
          { name: "化学" },
          { name: "地理" },
          { name: "历史" },
          { name: "生物" },
          { name: "政治" },
        ];
        this.color=[ { offset: 0, color: "#FAE17C" },
                  { offset: 0.9, color: "#FAE17C" },
                  { offset: 1, color: "#FAE17C" }];
        this.data = [
          {
            subject_name: "数学",
            count: "346402",
          },
          {
            subject_name: "语文",
            count: "267050",
          },
          {
            subject_name: "英语",
            count: "250264",
          },
          {
            subject_name: "物理",
            count: "187698",
          },
          {
            subject_name: "化学",
            count: "120554",
          },
          {
            subject_name: "地理",
            count: "111398",
          },
        ];
        color="#FAFA6B";
      }
      this.initHomework(seriesDataArr, indicator,color);
    },
    /**
     * 加载饼状图
     */
     initHomework(data, indicator,color) {
      let dataSourcePie = this.$echarts.init(
        document.getElementById("subjectApplicationAnalysis")
      );
      let radiusVal = 60;
      let fontSize = 12;
      // if (this.screenWidth <= 1280) {
      //   radiusVal = 30;
      // }
      const option = {
        // legend: {
        //     data: ['小学','初中', '高中']
        // },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              formatter: "{value}",
              color: "#708ACC",
              fontSize: fontSize,
            },
          },
          center: ["55%", "50%"],
          radius: radiusVal,
          shape: "circle",
          splitArea: {
            areaStyle: {
              color: color,
              opacity: 0.2,
              shadowColor: "#D2F7F9",
              shadowBlur: 10,
            },
          },
          splitLine: {
            lineStyle: {
              width: 1,
              color: color,
              opacity: 0.45,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#708ACC",
            },
          },
          indicator: indicator,
        },
        series: [
          {
            name: "",
            type: "radar",
            symbol: "none", //去掉边拐点
            itemStyle: {
              normal: {
                lineStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, this.color),
                },
              },
            },
            data: data,
          },
        ],
      };
      dataSourcePie.setOption(option);

      window.addEventListener("resize", function () {
        dataSourcePie.resize();
      });
    },
    },
    mounted() {
      this.selectLegend(0)
    }
}
</script>
<style lang='scss' scoped>
.teach-resource-build {
    width: 100%;
    height: 250px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;

    // background: rgba(6,17,52,0.8);
    .teach-resource-build-top {
        position: relative;
        text-align: center;
        margin-bottom: 15px;

        .title {
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }

        .more {
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }

        .title-bg {
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .teach-resource-build-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: calc(100% - 55px);

        .region-panorama-board-top-filter {
            position: absolute;
            left: 20px;
            top: 5%;
            display: flex;
            align-items: center;
            background: rgba(31, 51, 141, 0.57);
            border-radius: 4px;

            .filter-btn {
                padding: 5px 8px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #C1ECFF;
                cursor: pointer;
            }

            .is-select {
                background: #2B7FFF;
                border-radius: 4px;
                color: #FFFFFF;
            }
        }

        .right-container {
            width: 50%;

            .right-container-wrap {
                .subject-count-title {
                    display: flex;
                    color: #6EA0D3;
                    background: rgba(16, 34, 67, 0.5);
                    padding: 4px 0;
                }
                .subject-count-name{
                    display: flex;
                    color: #A1B6EB;
                    padding: 4px 0;
                }
            }
        }
    }
}

.top-left {
    position: absolute;
    top: 0;
    left: 0;
    width: 14px;
    height: 14px;
}

.top-right {
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
}

.left-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 14px;
    height: 14px;
}

.right-bottom {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 14px;
    height: 14px;
}</style>